module.exports = {"headline":"מקסימום <span class=\"halva\">Glow</span> במינימום זמן","desc":"למדי איך עושים את זה נכון"}


//////////////////
// WEBPACK FOOTER
// ./src/api/VideoComp.json
// module id = 57
// module chunks = 0